"use strict";
// Fishing factor model - en enskild faktor i fishing score
Object.defineProperty(exports, "__esModule", { value: true });
